import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../js/stores/language.js';
import user from '../../js/stores/user.js';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $f7router = _ref.$f7router;
  var locale = language.getters.Item.value;
  var username = '';
  var password = '';
  var updateUsername = function updateUsername(e) {
    username = e.target.value;
    $update();
  };
  var updatePassword = function updatePassword(e) {
    password = e.target.value;
    $update();
  };
  var checkLogin = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data, result, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            $f7.preloader.show();
            _context.prev = 1;
            data = {
              UserData: username,
              UserPassword: password
            };
            _context.next = 2;
            return user.dispatch('logIn', data);
          case 2:
            result = _context.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context.next = 3;
              break;
            }
            $f7.preloader.hide();
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context.abrupt("return");
          case 3:
            $f7.preloader.hide();
            $f7.toast.show({
              text: locale.translate('user.login.successfulLabel'),
              closeTimeout: 4000
            });
            $f7.views.main.router.navigate('/');
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            $f7.preloader.hide();
            $f7.toast.show({
              text: _t.message
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function checkLogin() {
      return _ref2.apply(this, arguments);
    };
  }();
  var pressEnter = function pressEnter(e) {
    if (e.keyCode === 13) {
      checkLogin();
    }
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="user-login">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="/" class="link">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Back</span>
          </a>
        </div>
        <div class="title">${locale.translate('user.login.title')}</div>
      </div>
    </div>
    <div class="page-content login-screen-content">
      <div class="login-screen-title">${locale.translate('user.login.title')}</div>
      <form id="user-login-form">
        <div class="list">
          <div class="preloader" style="display: none;"></div>
          <ul>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${locale.translate('user.login.userMailLabel')}</div>
                <div class="item-input-wrap">
                  <input id="username" type="text" name="username" value="${username}" @input="${updateUsername}" placeholder="${locale.translate('user.login.userMailPlaceHolder')}" autocomplete="off" />
                </div>
              </div>
            </li>
            <li class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${locale.translate('user.login.userPasswordLabel')}</div>
                <div class="item-input-wrap">
                  <input id="password" type="password" name="password" value="${password}" @input="${updatePassword}" placeholder="${locale.translate('user.login.userPasswordPlaceholder')}" autocomplete="off" @keypress="${pressEnter}" />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="block block-strong">
          <p class="grid grid-cols-3">
            <div>
              <a class="button button-outline link panel-close" href="/user-new/">
                <i class="material-symbols-outlined">app_registration</i>${locale.translate('user.login.newUserLabel')}
              </a>
            </div>
            <div></div>
            <div>
              <a class="login-btn button button-raised button-fill color-blue" href="#" @click="${checkLogin}">
                <i class="material-symbols-outlined">passkey</i>${locale.translate('user.login.loginButtonLabel')}
              </a>
            </div>
          </p>
          <div class="block-footer">
            <p>© Aplicaciones Digitales Caborca, 2019-2025 (v2.0)</p>
          </div>
        </div>
      </form>
    </div>
  </div>
`
    }
    ;
}
framework7Component.id = '170d360310';
export default framework7Component;